import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { isMobile, isTablet } from 'react-device-detect';
import Scene from './pages/Scene';
import { AppProvider } from './contexts/AppContext';
import DataSetManager from './managers/DataSetManager';
import LocationsManager from './managers/LocationsManager';
import DataStoreManager from './managers/DataStoreManager';
import DictionnaryManager from './managers/DictionnaryManager';
import { LOCAL_MODE } from './Config';

class App extends Component {
  constructor(props) {
    super(props);

    const { lang } = this.props;

    window.CONFIG = {
      backendURL: LOCAL_MODE
        ? 'http://dev.google.com:5000'
        : window.location.origin,
    };

    // TODO needs to fix / change that
    if (isMobile || isTablet) {
      document.querySelector('body').classList.add('mobile');
    }

    document.querySelector('body').classList.add(`lang-${lang}`);
  }

  render() {
    const { axl, params, lang } = this.props;

    const managers = {
      dictionnary: new DictionnaryManager('public', lang),
      dbManager: new DataStoreManager(),
      dsManager: new DataSetManager(),
      locManager: new LocationsManager(),
      axl,
    };

    return (
      <AppProvider value={managers}>
        <Switch>
          <Route path="/">
            <Scene params={params} lang={lang} />
          </Route>
        </Switch>
      </AppProvider>
    );
  }
}

export default App;
